/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Network_EyebrowInputs */

const en_endpoint_network_eyebrow = /** @type {(inputs: Endpoint_Network_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing and providers`)
};

const zh_hans1_endpoint_network_eyebrow = /** @type {(inputs: Endpoint_Network_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格与服务商`)
};

const pt_br2_endpoint_network_eyebrow = /** @type {(inputs: Endpoint_Network_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preços e provedores`)
};

const es_endpoint_network_eyebrow = /** @type {(inputs: Endpoint_Network_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precios y proveedores`)
};

const fr_endpoint_network_eyebrow = /** @type {(inputs: Endpoint_Network_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarifs et fournisseurs`)
};

const de_endpoint_network_eyebrow = /** @type {(inputs: Endpoint_Network_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preise und Anbieter`)
};

const ru_endpoint_network_eyebrow = /** @type {(inputs: Endpoint_Network_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цены и поставщики`)
};

const it_endpoint_network_eyebrow = /** @type {(inputs: Endpoint_Network_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzi e provider`)
};

/**
* | output |
* | --- |
* | "Pricing and providers" |
*
* @param {Endpoint_Network_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_network_eyebrow = /** @type {((inputs?: Endpoint_Network_EyebrowInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Network_EyebrowInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_network_eyebrow(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_network_eyebrow(inputs)
	if (locale === "es") return es_endpoint_network_eyebrow(inputs)
	if (locale === "fr") return fr_endpoint_network_eyebrow(inputs)
	if (locale === "de") return de_endpoint_network_eyebrow(inputs)
	if (locale === "ru") return ru_endpoint_network_eyebrow(inputs)
	if (locale === "it") return it_endpoint_network_eyebrow(inputs)
	return en_endpoint_network_eyebrow(inputs)
});